import { loadMessages, locale } from "devextreme/localization";
import { useEffect } from "react";

//indien fout 'modole not found': run: 'npm run build' and check if typeings.d.ts exists (should be a typed json, we just use any for now)
import * as nlMessages from "devextreme/localization/messages/nl.json";

const useDutchDevExtreme = () => {

    useEffect(() => {
        loadMessages({
            nl: {
                ...nlMessages["nl"],
                "dxHtmlEditor-dialogInsertTableRowsField": "Rijen",
                "dxHtmlEditor-dialogInsertTableColumnsField": "Kolommen",
                "dxHtmlEditor-dialogInsertTableCaption": "Tabel invoegen",
                "dxHtmlEditor-heading": "Titel",
                "dxHtmlEditor-normalText": "Normale tekst",
                "dxHtmlEditor-background": "Achtergrond",
                "dxHtmlEditor-bold": "Vet",
                "dxHtmlEditor-color": "Kleur",
                "dxHtmlEditor-font": "Lettertype",
                "dxHtmlEditor-italic": "Cursief",
                "dxHtmlEditor-link": "Link",
                "dxHtmlEditor-image": "Afbeelding",
                "dxHtmlEditor-size": "Grootte",
                "dxHtmlEditor-strike": "Doorhalen",
                "dxHtmlEditor-subscript": "subscript",
                "dxHtmlEditor-superscript": "superscript",
                "dxHtmlEditor-underline": "Onderstrepen",
                "dxHtmlEditor-blockquote": "blokquote",
                "dxHtmlEditor-header": "Hoofding",
                "dxHtmlEditor-increaseIndent": "Inspringing vergroten",
                "dxHtmlEditor-decreaseIndent": "Inspringing verkleinen",
                "dxHtmlEditor-orderedList": "Nummering",
                "dxHtmlEditor-bulletList": "Opsommingstekens",
                "dxHtmlEditor-alignLeft": "Links uitlijnen",
                "dxHtmlEditor-alignCenter": "Centreren",
                "dxHtmlEditor-alignRight": "Rechts uilijnen",
                "dxHtmlEditor-alignJustify": "Uitvullen",
                "dxHtmlEditor-codeBlock": "Codeblok",
                "dxHtmlEditor-variable": "Variable",
                "dxHtmlEditor-undo": "Ongedaan maken",
                "dxHtmlEditor-redo": "opnieuw uitvoeren",
                "dxHtmlEditor-clear": "Opmaak wissen",
                "dxHtmlEditor-insertTable": "Tabel invoegen",
                "dxHtmlEditor-insertRowAbove": "Rij boven invoegen",
                "dxHtmlEditor-insertRowBelow": "Rij onder invoegen",
                "dxHtmlEditor-insertColumnLeft": "Kolom links invoegen",
                "dxHtmlEditor-insertColumnRight": "Kolom rechts invoegen",
                "dxHtmlEditor-deleteColumn": "Verwijder kolom",
                "dxHtmlEditor-deleteRow": "Verwijder rij",
                "dxHtmlEditor-deleteTable": "Verwijder tabel",
                "dxHtmlEditor-list": "Lijst",
                "dxHtmlEditor-ordered": "Geordend",
                "dxHtmlEditor-bullet": "Genummerd",
                "dxHtmlEditor-align": "Uitlijnen",
                "dxHtmlEditor-center": "Centreren",
                "dxHtmlEditor-left": "Links",
                "dxHtmlEditor-right": "Rechts",
                "dxHtmlEditor-indent": "Inspringen",
                "dxHtmlEditor-justify": "Uitvullen",
            }
        })
        locale("nl");
    }, [])


    return null;
}
export default useDutchDevExtreme;